import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from '@angular/router';
import { LoginService } from '../service/login.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EnvconfigService } from '../service/envconfig.service';
import { EncryptDecryptService } from '../service/EncryptDecryptService.service';

@Injectable({
  providedIn: 'root'
})

  class InternalAppGuardService  {

    constructor(
      private loginService: LoginService,
      private router: Router,
      private environment: EnvconfigService,
      private JwtHelper:JwtHelperService,
      private encryptService: EncryptDecryptService
    ) { }
    
    canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): boolean {
  
      //1) VERIFICAR SI ESTA LOGUEADO       
      let rpta = this.loginService.estaLogueado();   
      if (!rpta) {
        this.loginService.cerrarSesion();
        return false;
      } else {
        //2) VERIFICAR SI EL TOKEN NO HA EXPIRADO
        let token = sessionStorage.getItem(this.environment.get("TOKEN_NAME"))!;
        let _token =this.encryptService.decrypt(token,this.environment.get("keyCaptcha"));
        if (!this.JwtHelper.isTokenExpired(_token)) {
          //3) VERIFICAR SI TIENES EL ROL NECESARIO PARA ACCEDER A ESA PAGINA        
            this.JwtHelper.decodeToken(_token);
            return true
        }
        else {
          this.loginService.cerrarSesion();
          return false;
        }
      }
    }  
}
export const AppGuardService: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(InternalAppGuardService).canActivate(next, state);
}